<template>
  <BaseModal modalColor="border-warning bg-warning" iconModal="fa fa-warning" subtitulo="Editar saida" col-md="col-md-5"
             offset="offset-3">
    <template v-slot:modalContent>
      <form ref="editarForm" @submit.prevent="submitEditForm">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label><strong>Construção: <span class="text-danger font-bold">*</span></strong></label>
              <p class="font-bold"> {{ dado.construcao_exibicao }}</p>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <DatePicker id="data_cadastro" v-model="dado.data_cadastro" showIcon iconDisplay="input"
                            size="small" style="width: 100%" appendTo="body" ref="dataCadastro" dateFormat="dd/mm/yyyy"
                            :invalid="campoVazio.includes('data_cadastro')"/>
                <label for="data_inicio"><strong>Data Cadastro: <span class="text-danger font-bold">*</span></strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <DatePicker id="data_entrega" v-model="dado.data_entrega" showIcon iconDisplay="input"
                            size="small" style="width: 100%" appendTo="body" ref="dataEntrega" dateFormat="dd/mm/yyyy"
                            :invalid="campoVazio.includes('data_entrega')"/>
                <label for="data_entrega"><strong>Data Entrega: <span class="text-danger font-bold">*</span></strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="observacao" v-model="dado.observacao" size="small" style="width: 100%"/>
                <label for="observacao"><strong>Observação: </strong></label>
              </FloatLabel>
            </div>
          </div>
        </div>
        <div class="ibox-footer">
          <div class="float-right">
            <button type="submit" class="btn btn-primary font-bold">Confirmar</button>
          </div>
          <button class="btn btn-danger font-bold" @click="$emit('fechar')">
            Cancelar
          </button>
        </div>
      </form>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/base/BaseModal.vue';
import {apiRequest, denormalizeDates, normalizeDates} from "../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes";
import moment from "moment";


export default {
  name: "EditarSaida",
  components: {
    BaseModal,
  },
  props: {
    itemId: Number,
    itemKey: String,
  },
  data() {
    return {
      dado: 1,
      erro: null,
      campoVazio: [],
    }
  },
  emits: ["fechar", "atualizarDados"],
  methods: {
    async getDados() {
      const resultado = await apiRequest("GET", `${apiUrl.saidas.retrieveUpdateDestroy(this.itemKey)}?modo=edit`);
      if (resultado.success) {
        this.dado = resultado.data;
        normalizeDates(this.dado, ['data_cadastro', 'data_entrega']);
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async submitEditForm() {
      denormalizeDates(this.dado, ['data_cadastro', 'data_entrega']);
      const resultado = await apiRequest("PATCH", apiUrl.saidas.retrieveUpdateDestroy(this.itemKey), this.dado);
      if (resultado.success) {
        ['data_cadastro', 'data_entrega', 'construcao'].forEach(field => {
          if (field === 'construcao') {
            resultado.data[field] = this.dado.construcao_exibicao;
          } else {
            resultado.data[field] = moment(resultado.data[field]).format('DD/MM/YYYY');
          }
        });
        this.$emit("atualizarDados", resultado.data);
        this.$toastMessage("success", "Registro alterado com sucesso!");
        this.$emit('fechar');
      } else {
        this.campoVazio = Object.keys(resultado.error);
        if (resultado.error && typeof resultado.error === "object") {
          for (const campo in resultado.error) {
            resultado.error[campo].forEach(msg => {
              this.$toastMessage("error", campo, msg);
            });
          }
        } else {
          this.$toastMessage("warn", "Atenção", "Erro inesperado ao salvar!");
        }
      }
    },
  },
  mounted() {
    this.getDados();
    Inputmask("99/99/9999").mask(this.$refs.dataCadastro.$el.querySelector("input"));
    Inputmask("99/99/9999").mask(this.$refs.dataEntrega.$el.querySelector("input"));
  },
}
</script>
